import { io } from "socket.io-client";
const sockets = {};
const defaultOptions = {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000, 
  reconnectionDelayMax: 5000,
  timeout: 10000,
};

export const initSocket = (type, url, customOptions = {}) => {
  if (sockets[type]) {
    console.warn(`[Socket][${type}] Already initialized`);
    return sockets[type];
  }
  console.log(`[Socket] Initializing socket: ${type}`);

  const socket = io(url, {
    ...defaultOptions,
    ...customOptions,
  });

  socket.on("connect", () => {
    console.log(`[Socket][${type}] ✅ Connected: ${socket.id}`);
  });

  socket.on("disconnect", (reason) => {
    console.warn(`[Socket][${type}] ⚠️ Disconnected: ${reason}`);
  });

  socket.on("connect_error", (err) => {
    console.error(`[Socket][${type}] ❌ Connection Error: ${err.message}`);
  });

  sockets[type] = socket;
  return socket;
};

export const getSocket = (type) => {
  return sockets[type];
};

export const disconnectSocket = (type) => {
  if (sockets[type]) {
    sockets[type].disconnect();
    // console.log(`[Socket][${type}] 🔌 Disconnected manually`);
    delete sockets[type];
  }
};

export const onSocketEvent = (type, event, callback) => {
  const socket = getSocket(type);
  if (socket) {
    // console.log(`[Socket][${type}] 📥 Listening for: '${event}'`);
    socket.on(event, callback);
  }
};

export const offSocketEvent = (type, event) => {
  const socket = getSocket(type);
  if (socket) {
    // console.log(`[Socket][${type}] ❌ Stopped listening: '${event}'`);
    socket.off(event);
  }
};

export const emitSocketEvent = (type, event, payload) => {
  const socket = getSocket(type);
  if (socket) {
    // console.log(`[Socket][${type}] 📤 Emitting: '${event}'`, payload);
    socket.emit(event, payload);
  }
};
